import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/core/auth'
import { apiClient } from '@/core/api/client'

const VOICEMAIL_UNREAD_COUNT_KEY = ['voip', 'voicemail', 'unread-count']

// Compteur de messages vocaux non écoutés — alimente le badge rouge de
// l'onglet "Appels" dans la navbar. Pas d'événement temps réel côté
// messagerie (les messages arrivent par des appels externes), donc
// simple polling.
export const useVoicemailUnreadCount = () => {
  const { user, isAuthenticated } = useAuth()
  const enabled = Boolean(
    isAuthenticated && user && (user.role === 'admin' || user.role === 'bureau'),
  )

  const { data, isLoading, refetch } = useQuery({
    queryKey: VOICEMAIL_UNREAD_COUNT_KEY,
    queryFn: async (): Promise<number> => {
      try {
        const res = await apiClient.get<{ count: number }>(
          '/api/voip/voicemails/unread-count',
        )
        return res.count ?? 0
      } catch {
        return 0
      }
    },
    enabled,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
  })

  return { unreadCount: data ?? 0, isLoading, refetch }
}

export default useVoicemailUnreadCount
